import { FC } from 'react'
import { OnboardingDesktop } from './flows'
import cx from 'classnames'
import styles from './modal.module.scss'
import { Modal } from '../Modal'
import { useOnboardingType } from '@/hooks/useOnboardingType'
import {
  OnboardingStepProvider,
  useOnboardingSteps,
} from '@/context/OnboardingStepContext/OnboardingStepContext'

interface Props {
  onClose: () => void
  maxStep?: number
}

const OnboardingInner: FC<Props> = ({ onClose }) => {
  const onboardingType = useOnboardingType()

  const modalClassName = cx(styles[`${onboardingType}Modal`])

  const { goBack, step } = useOnboardingSteps()

  const handleBackAction = () => {
    if (step > 0) {
      goBack()
      return
    }
    onClose()
  }

  return (
    <Modal
      id={`onboarding-${onboardingType}`}
      onClose={onClose}
      className={modalClassName}
      handleBackAction={handleBackAction}
    >
      <OnboardingDesktop />
    </Modal>
  )
}
export const Onboarding: FC<Props> = ({ maxStep, ...rest }) => (
  <OnboardingStepProvider maxStep={maxStep} initialStep={0}>
    <OnboardingInner {...rest} />
  </OnboardingStepProvider>
)
